import requestFlow from '@/utils/requestFlow'
import { companyOpportunitiesRoutine, aggregatorOpportunityIdRoutine, aggregatorFormSubmittedRoutine, OPPORTUNITY_CLEANUP } from './routines'

export default {
  ...requestFlow(companyOpportunitiesRoutine).mockMutations,

  [companyOpportunitiesRoutine.SUCCESS](state, payload) {
    state.companyOpportunities = payload
  },

  [aggregatorOpportunityIdRoutine.TRIGGER](state, payload) {
    state.aggregatorOpportunityId = payload
  },

  [aggregatorFormSubmittedRoutine.SUCCESS](state, payload) {
    state.isILOFormSubmitted = payload
  },

  [OPPORTUNITY_CLEANUP](state, payload) {
    Object.assign(state, payload)
  }
}
